// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weave-table-container {
  --table-bg-color: #fff;
  --table-border-color: var(--cui-border-color, #d8dbe0);
  --table-text-color: var(--cui-body-color, #4f5d73);
  --filter-bg-color: #f8f9fa;
  --filter-border-color: #dee2e6;
  --filter-focus-color: var(--cui-primary, #0d6efd);
}
html[data-coreui-theme=dark] .weave-table-container {
  --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);
  --table-border-color: var(--cui-dark-border-subtle, #333);
  --table-text-color: var(--cui-body-color, #fff);
  --filter-bg-color: #2a2d3a;
  --filter-border-color: #404552;
  --filter-focus-color: var(--cui-primary, #0d6efd);
}
.weave-table-container .table {
  border-color: var(--table-border-color) !important;
  margin-bottom: 0;
}
.weave-table-container .table,
.weave-table-container .table thead,
.weave-table-container .table tbody,
.weave-table-container .table tr,
.weave-table-container .table th,
.weave-table-container .table td {
  border-color: var(--table-border-color) !important;
}
.weave-table-container .table:hover,
.weave-table-container .table thead:hover,
.weave-table-container .table tbody:hover,
.weave-table-container .table tr:hover,
.weave-table-container .table th:hover,
.weave-table-container .table td:hover {
  border-color: var(--table-border-color) !important;
}
.weave-table-container .card {
  border-color: var(--table-border-color) !important;
  background-color: var(--table-bg-color);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.weave-table-container .card:hover {
  border-color: var(--table-border-color) !important;
}
.weave-table-container .card .card-body {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.weave-table-container .weave-table {
  width: 100%;
  color: var(--table-text-color);
}
.weave-table-container .weave-table .table-header-cell {
  border-color: var(--table-border-color) !important;
  font-weight: 600;
  background-color: var(--filter-bg-color);
}
.weave-table-container .weave-table .table-header-cell.sortable-header {
  cursor: pointer;
  transition: all 0.2s ease;
}
.weave-table-container .weave-table .table-header-cell.sortable-header:hover {
  background-color: var(--filter-focus-color);
  color: white;
}
.weave-table-container .weave-table .table-header-cell:hover {
  border-color: var(--table-border-color) !important;
}
.weave-table-container .weave-table tbody tr {
  border-color: var(--table-border-color) !important;
  transition: all 0.2s ease;
}
.weave-table-container .weave-table tbody tr:hover {
  border-color: var(--table-border-color) !important;
  background-color: var(--filter-bg-color) !important;
}
.weave-table-container .weave-table tbody tr td {
  border-color: var(--table-border-color) !important;
}
.weave-table-container .weave-table tbody tr td:hover {
  border-color: var(--table-border-color) !important;
}
.weave-table-container .filter-controls .filter-toggle-btn {
  position: relative;
  transition: all 0.3s ease;
}
.weave-table-container .filter-controls .filter-toggle-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.weave-table-container .filter-controls .filter-toggle-btn .filter-count-badge {
  background-color: #dc3545;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 0.75rem;
  font-weight: 600;
  min-width: 18px;
  text-align: center;
  display: inline-block;
  animation: pulse 2s infinite;
}
.weave-table-container .filter-controls .clear-filters-btn {
  transition: all 0.2s ease;
}
.weave-table-container .filter-controls .clear-filters-btn:hover {
  color: #dc3545;
  border-color: #dc3545;
}
.weave-table-container .filter-controls .results-info .filtered-info {
  color: var(--cui-secondary);
  font-style: italic;
}
.weave-table-container .filter-panel {
  background-color: var(--filter-bg-color);
  border: 1px solid var(--filter-border-color);
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
}
.weave-table-container .filter-panel .filter-field .filter-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--table-text-color);
  margin-bottom: 0.5rem;
}
.weave-table-container .filter-panel .filter-field .filter-label--compact {
  font-size: 0.75rem;
  line-height: 1.2;
  min-height: 1.3125rem;
  display: flex;
  align-items: flex-end;
}
.weave-table-container .filter-panel .filter-field .filter-select {
  background-color: var(--table-bg-color);
  border-color: var(--filter-border-color);
  color: var(--table-text-color);
}
.weave-table-container .filter-panel .filter-field .filter-select:focus {
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}
.weave-table-container .filter-panel .filter-field .decimal-input-group {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
.weave-table-container .filter-panel .filter-field .decimal-input-group .whole-input {
  flex: 1 1;
  min-width: 0;
}
.weave-table-container .filter-panel .filter-field .decimal-input-group .decimal-separator {
  color: #6c757d;
  font-weight: 600;
  line-height: 1;
}
.weave-table-container .filter-panel .filter-field .decimal-input-group .decimal-input {
  width: 64px;
  flex: 0 0 64px;
  text-align: center;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper {
  position: relative;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--cui-secondary);
  z-index: 5;
  pointer-events: none;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input {
  padding-left: 35px;
  padding-right: 35px;
  border: 1px solid var(--filter-border-color);
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  transition: all 0.2s ease;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input:focus {
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input::placeholder {
  color: var(--cui-secondary);
  opacity: 0.7;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-clear-btn {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
  width: 20px;
  height: 20px;
  border: none;
  background: none;
  color: var(--cui-secondary);
  z-index: 5;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-clear-btn:hover {
  color: #dc3545;
  background: none;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-trigger {
  min-height: 1.9375rem !important;
  padding: 0.375rem 0.5rem !important;
  background-color: #fff !important;
  border: 1px solid #b1b7c1 !important;
  border-radius: 0.375rem !important;
  box-shadow: none !important;
  transform: none !important;
}
html[data-coreui-theme=dark] .weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-trigger {
  background-color: var(--cui-body-bg, #212631) !important;
  border-color: var(--cui-border-color, #495057) !important;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-trigger:hover:not(.disabled) {
  border-color: #86b7fe !important;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-trigger:focus, .weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-trigger.open {
  border-color: #86b7fe !important;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
  transform: none !important;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-trigger .select-value {
  font-size: 0.875rem;
  color: #212529;
}
html[data-coreui-theme=dark] .weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-trigger .select-value {
  color: var(--cui-body-color, #fff);
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-trigger .select-value .placeholder {
  color: #6c757d !important;
  font-style: normal !important;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-trigger .select-icons {
  gap: 0.15rem !important;
  margin-left: 0.25rem !important;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-trigger .select-icons .clear-btn {
  width: 1rem !important;
  height: 1rem !important;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-trigger .select-icons .chevron {
  color: #6c757d;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown {
  border: 1px solid #b1b7c1 !important;
  border-top: none !important;
  border-radius: 0 0 0.375rem 0.375rem !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  background: #fff !important;
}
html[data-coreui-theme=dark] .weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown {
  background: var(--cui-body-bg, #212631) !important;
  border-color: var(--cui-border-color, #495057) !important;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown .search-container {
  padding: 0.5rem !important;
  background: #f8f9fa !important;
  border-bottom: 1px solid #dee2e6 !important;
}
html[data-coreui-theme=dark] .weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown .search-container {
  background: var(--cui-tertiary-bg, #2c3034) !important;
  border-bottom-color: var(--cui-border-color, #495057) !important;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown .search-container .search-input {
  padding: 0.375rem 0.75rem 0.375rem 2rem !important;
  border: 1px solid #ced4da !important;
  border-radius: 0.375rem !important;
  font-size: 0.875rem !important;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown .search-container .search-input:focus {
  border-color: #86b7fe !important;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown .options-container .option-item {
  padding: 0.375rem 0.75rem !important;
  font-size: 0.875rem !important;
  color: #212529;
}
html[data-coreui-theme=dark] .weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown .options-container .option-item {
  color: var(--cui-body-color, #fff);
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown .options-container .option-item:hover, .weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown .options-container .option-item.highlighted {
  background-color: #e9ecef !important;
}
html[data-coreui-theme=dark] .weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown .options-container .option-item:hover, html[data-coreui-theme=dark] .weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown .options-container .option-item.highlighted {
  background-color: var(--cui-tertiary-bg, #2c3034) !important;
}
.weave-table-container .filter-panel .filter-field .filter-input-wrapper .filter-searchable-select .select-dropdown .options-container .option-item.selected {
  background-color: #0d6efd !important;
  color: #fff !important;
}
.weave-table-container .no-data-message .loading-message {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--table-text-color);
}
.weave-table-container .no-data-message .no-results-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--cui-secondary);
}
.weave-table-container .no-data-message .no-results-message .btn-link {
  color: var(--filter-focus-color);
  text-decoration: none;
}
.weave-table-container .no-data-message .no-results-message .btn-link:hover {
  text-decoration: underline;
}
.weave-table-container .pagination {
  margin-bottom: 0;
}
.weave-table-container .pagination .page-item .page-link {
  color: var(--table-text-color);
  background-color: var(--table-bg-color);
  border-color: var(--filter-border-color);
}
.weave-table-container .pagination .page-item .page-link:hover {
  color: var(--filter-focus-color);
  background-color: var(--filter-bg-color);
  border-color: var(--filter-focus-color);
}
.weave-table-container .pagination .page-item.active .page-link {
  background-color: var(--filter-focus-color);
  border-color: var(--filter-focus-color);
  color: white;
}
.weave-table-container .pagination .page-item.disabled .page-link {
  color: var(--cui-secondary);
  background-color: var(--table-bg-color);
  border-color: var(--filter-border-color);
}
.weave-table-container .form-select {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  border-color: var(--filter-border-color);
}
.weave-table-container .form-select:focus {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
}
.weave-table-container .form-select option {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.weave-table-container .cursor-pointer {
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 4px;
}
.weave-table-container .cursor-pointer:hover {
  opacity: 0.8;
  transform: scale(1.1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}
@media (max-width: 768px) {
  .weave-table-container .filter-panel {
    padding: 1rem;
  }
  .weave-table-container .filter-panel .row {
    --bs-gutter-x: 0.5rem;
  }
  .weave-table-container .filter-panel .filter-field {
    margin-bottom: 1rem;
  }
  .weave-table-container .filter-controls .d-flex {
    flex-direction: column;
    gap: 0.5rem;
    align-items: stretch !important;
  }
  .weave-table-container .filter-controls .d-flex .d-flex {
    flex-direction: row;
    align-items: center !important;
  }
  .weave-table-container .d-flex.justify-content-between.align-items-center.mt-3 {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch !important;
  }
  .weave-table-container .d-flex.justify-content-between.align-items-center.mt-3 .d-flex {
    justify-content: center;
  }
  .weave-table-container .d-flex.justify-content-between.align-items-center.mt-3 .text-muted {
    text-align: center;
  }
}
@media (max-width: 576px) {
  .weave-table-container .filter-panel .col-lg-3, .weave-table-container .filter-panel .col-md-4, .weave-table-container .filter-panel .col-sm-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .weave-table-container .filter-panel .filter-field {
    margin-bottom: 0.75rem;
  }
  .weave-table-container .filter-panel .filter-field .filter-label {
    font-size: 0.8rem;
  }
  .weave-table-container .filter-panel .filter-field .filter-input {
    font-size: 0.875rem;
  }
  .weave-table-container .filter-controls .filter-toggle-btn, .weave-table-container .filter-controls .clear-filters-btn {
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
  }
  .weave-table-container .filter-controls .results-info {
    font-size: 0.875rem;
    text-align: center;
  }
}
html[data-coreui-theme=dark] .weave-table-container .card {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
html[data-coreui-theme=dark] .weave-table-container .filter-panel {
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
}
html[data-coreui-theme=dark] .weave-table-container .filter-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.4);
}
html[data-coreui-theme=dark] .weave-table-container .cursor-pointer:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
html[data-coreui-theme=dark] .weave-table-container .pagination .page-item .page-link:hover {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.weave-table-container * {
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}
.weave-table-container .expand-cell {
  width: 40px;
  padding: 0.5rem 0.25rem !important;
  text-align: center;
  vertical-align: middle;
}
.weave-table-container .expand-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}
.weave-table-container .expand-button:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
}
.weave-table-container .expand-button .expand-icon {
  transition: transform 0.3s ease;
}
.weave-table-container .expanded-row {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
}
html[data-coreui-theme=dark] .weave-table-container .expanded-row {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
}
.weave-table-container .detail-row {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-top: none !important;
}
html[data-coreui-theme=dark] .weave-table-container .detail-row {
  background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);
}
.weave-table-container .detail-row .detail-cell {
  padding: 1.5rem !important;
  border-top: 2px solid var(--cui-primary, #0d6efd);
}
.weave-table-container .detail-content {
  animation: slideDown 0.3s ease-out;
}
.weave-table-container .detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  padding: 1rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--cui-border-color, #d8dbe0);
}
html[data-coreui-theme=dark] .weave-table-container .detail-grid {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
.weave-table-container .detail-grid.detail-grid--preview {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.weave-table-container .detail-item--action {
  cursor: pointer;
}
.weave-table-container .detail-item--action .detail-value--action {
  background: rgba(25, 135, 84, 0.12);
  border-color: rgba(25, 135, 84, 0.25);
  color: #157347;
}
.weave-table-container .detail-item--action:hover .detail-value--action {
  background: rgba(25, 135, 84, 0.2);
  border-color: rgba(25, 135, 84, 0.35);
}
.weave-table-container .detail-item--action:focus-visible {
  outline: 2px solid rgba(13, 110, 253, 0.45);
  outline-offset: 2px;
}
.weave-table-container .detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  border: 1px solid var(--cui-border-color, #d8dbe0);
  transition: all 0.3s ease;
}
.weave-table-container .detail-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
html[data-coreui-theme=dark] .weave-table-container .detail-item {
  background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);
  border-color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .weave-table-container .detail-item:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}
.weave-table-container .detail-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--cui-secondary-color, #6c757d);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
html[data-coreui-theme=dark] .weave-table-container .detail-label {
  color: var(--cui-secondary-color, #8a93a2);
}
.weave-table-container .detail-value {
  font-size: 1rem;
  font-weight: 700;
  color: var(--cui-primary, #0d6efd);
  padding: 0.5rem;
  background: rgba(13, 110, 253, 0.1);
  border-radius: 6px;
  text-align: center;
  border: 1px solid rgba(13, 110, 253, 0.2);
}
html[data-coreui-theme=dark] .weave-table-container .detail-value {
  background: rgba(13, 110, 253, 0.2);
  border-color: rgba(13, 110, 253, 0.3);
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  .weave-table-container .detail-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 0.75rem;
  }
  .weave-table-container .detail-grid.detail-grid--preview {
    grid-template-columns: 1fr;
  }
  .weave-table-container .detail-item {
    padding: 0.75rem;
  }
  .weave-table-container .detail-value {
    font-size: 0.875rem;
    padding: 0.375rem;
  }
}
.weave-table-container .caglik-preview-modal-body {
  max-height: 84vh;
  overflow: auto;
  padding: 0.5rem;
}

/* Keep Caglik preview modal wider than CoreUI's default xl width. */
.caglik-preview-modal .modal-dialog {
  width: 98vw;
  max-width: min(2000px, 98vw) !important;
  margin: 0.75rem auto;
}
.caglik-preview-modal .modal-content {
  min-height: 86vh;
}

.weavecolors-section {
  background: linear-gradient(135deg, #f8f9ff 0%, #fff0f6 100%);
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid var(--cui-border-color, #e0e6ff);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  animation: fadeInUp 0.6s ease-out;
}
.weavecolors-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
}
html[data-coreui-theme=dark] .weavecolors-section {
  background: linear-gradient(135deg, #1a1d29 0%, #252841 100%);
  border-color: var(--cui-dark-border-subtle, #333);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}
.weavecolors-section .weavecolors-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--cui-border-color, #e0e6ff);
}
html[data-coreui-theme=dark] .weavecolors-section .weavecolors-header {
  border-bottom-color: var(--cui-dark-border-subtle, #333);
}
.weavecolors-section .weavecolors-header .section-title {
  color: var(--cui-primary, #667eea);
  font-weight: 700;
  font-size: 1.25rem;
  margin: 0;
  display: flex;
  align-items: center;
}
html[data-coreui-theme=dark] .weavecolors-section .weavecolors-header .section-title {
  color: #8b9dc3;
}
.weavecolors-section .weavecolors-header .color-summary {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}
.weavecolors-section .weavecolors-header .summary-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 2px solid;
  transition: all 0.3s ease;
}
.weavecolors-section .weavecolors-header .summary-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.weavecolors-section .weavecolors-header .summary-badge.weft-badge {
  background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
  color: white;
  border-color: #ff6b6b;
}
html[data-coreui-theme=dark] .weavecolors-section .weavecolors-header .summary-badge.weft-badge {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
}
.weavecolors-section .weavecolors-header .summary-badge.warp-badge {
  background: linear-gradient(135deg, #4ecdc4, #44a08d);
  color: white;
  border-color: #4ecdc4;
}
html[data-coreui-theme=dark] .weavecolors-section .weavecolors-header .summary-badge.warp-badge {
  background: linear-gradient(135deg, #16a085, #138d75);
}
.weavecolors-section .weavecolors-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: 1fr;
}
@media (min-width: 992px) {
  .weavecolors-section .weavecolors-grid {
    grid-template-columns: 1fr 1fr;
  }
}
.weavecolors-section .thread-type-section {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid var(--cui-border-color, #e0e6ff);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}
.weavecolors-section .thread-type-section:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
html[data-coreui-theme=dark] .weavecolors-section .thread-type-section {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}
html[data-coreui-theme=dark] .weavecolors-section .thread-type-section:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}
.weavecolors-section .thread-type-section.weft-section {
  border-left: 4px solid #ff6b6b;
}
.weavecolors-section .thread-type-section.warp-section {
  border-left: 4px solid #4ecdc4;
}
.weavecolors-section .thread-type-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--cui-border-color, #e0e6ff);
}
html[data-coreui-theme=dark] .weavecolors-section .thread-type-header {
  border-bottom-color: var(--cui-dark-border-subtle, #333);
}
.weavecolors-section .thread-type-header .thread-type-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
}
.weavecolors-section .thread-type-header .thread-type-indicator.weft-indicator {
  background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
}
.weavecolors-section .thread-type-header .thread-type-indicator.warp-indicator {
  background: linear-gradient(135deg, #4ecdc4, #44a08d);
}
.weavecolors-section .thread-type-header .thread-type-title {
  flex: 1 1;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--cui-body-color, #4f5d73);
}
html[data-coreui-theme=dark] .weavecolors-section .thread-type-header .thread-type-title {
  color: var(--cui-body-color, #fff);
}
.weavecolors-section .thread-type-header .thread-count-badge {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 24px;
  text-align: center;
}
.weavecolors-section .colors-container {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
}
@media (max-width: 768px) {
  .weavecolors-section .colors-container {
    grid-template-columns: 1fr;
  }
}
.weavecolors-section .color-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  padding: 1.25rem;
  border: 1px solid var(--cui-border-color, #e0e6ff);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.weavecolors-section .color-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  transition: all 0.3s ease;
}
.weavecolors-section .color-card:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);
  border-color: var(--cui-primary, #667eea);
}
html[data-coreui-theme=dark] .weavecolors-section .color-card {
  background: linear-gradient(135deg, var(--cui-dark-bg, #212631) 0%, #1a1d29 100%);
  border-color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .weavecolors-section .color-card:hover {
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.4);
}
.weavecolors-section .color-card.weft-card::before {
  background: linear-gradient(90deg, #ff6b6b, #ff8e8e);
}
.weavecolors-section .color-card.warp-card::before {
  background: linear-gradient(90deg, #4ecdc4, #44a08d);
}
.weavecolors-section .color-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--cui-border-color, #e0e6ff);
}
html[data-coreui-theme=dark] .weavecolors-section .color-card-header {
  border-bottom-color: var(--cui-dark-border-subtle, #333);
}
.weavecolors-section .color-card-header .color-id-badge {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 0.375rem 0.75rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.weavecolors-section .color-card-header .position-indicator {
  background: rgba(102, 126, 234, 0.1);
  color: var(--cui-primary, #667eea);
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid rgba(102, 126, 234, 0.2);
}
html[data-coreui-theme=dark] .weavecolors-section .color-card-header .position-indicator {
  background: rgba(102, 126, 234, 0.2);
  border-color: rgba(102, 126, 234, 0.3);
}
.weavecolors-section .color-card-body .yarn-info {
  margin-bottom: 1rem;
}
.weavecolors-section .color-card-body .yarn-info .yarn-code {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--cui-primary, #667eea);
  margin-bottom: 0.5rem;
}
html[data-coreui-theme=dark] .weavecolors-section .color-card-body .yarn-info .yarn-code {
  color: #8b9dc3;
}
.weavecolors-section .color-card-body .yarn-info .yarn-name {
  font-size: 0.875rem;
  color: var(--cui-secondary-color, #6c757d);
  font-style: italic;
}
html[data-coreui-theme=dark] .weavecolors-section .color-card-body .yarn-info .yarn-name {
  color: #8a93a2;
}
.weavecolors-section .color-card-body .thread-specs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}
.weavecolors-section .color-card-body .spec-item {
  background: rgba(102, 126, 234, 0.05);
  border: 1px solid rgba(102, 126, 234, 0.1);
  border-radius: 8px;
  padding: 0.75rem;
  text-align: center;
  transition: all 0.3s ease;
}
.weavecolors-section .color-card-body .spec-item:hover {
  background: rgba(102, 126, 234, 0.1);
  border-color: rgba(102, 126, 234, 0.2);
  transform: scale(1.05);
}
html[data-coreui-theme=dark] .weavecolors-section .color-card-body .spec-item {
  background: rgba(102, 126, 234, 0.1);
  border-color: rgba(102, 126, 234, 0.2);
}
html[data-coreui-theme=dark] .weavecolors-section .color-card-body .spec-item:hover {
  background: rgba(102, 126, 234, 0.15);
  border-color: rgba(102, 126, 234, 0.3);
}
.weavecolors-section .color-card-body .spec-item .spec-label {
  display: block;
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--cui-secondary-color, #6c757d);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
html[data-coreui-theme=dark] .weavecolors-section .color-card-body .spec-item .spec-label {
  color: #8a93a2;
}
.weavecolors-section .color-card-body .spec-item .spec-value {
  display: block;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cui-primary, #667eea);
}
html[data-coreui-theme=dark] .weavecolors-section .color-card-body .spec-item .spec-value {
  color: #8b9dc3;
}
@media (max-width: 768px) {
  .weavecolors-section {
    padding: 1rem;
  }
  .weavecolors-section .weavecolors-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .weavecolors-section .weavecolors-header .color-summary {
    justify-content: center;
  }
  .weavecolors-section .thread-type-section {
    padding: 1rem;
  }
  .weavecolors-section .color-card {
    padding: 1rem;
  }
  .weavecolors-section .thread-specs {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 576px) {
  .weavecolors-section {
    margin: 0 -0.5rem;
    border-radius: 12px;
  }
  .weavecolors-section .weavecolors-header .section-title {
    font-size: 1.1rem;
  }
  .weavecolors-section .weavecolors-header .summary-badge {
    font-size: 0.75rem;
    padding: 0.375rem 0.75rem;
  }
  .weavecolors-section .colors-container {
    grid-template-columns: 1fr;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.weavecolors-skeleton .skeleton-item {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 8px;
  height: 20px;
  margin-bottom: 0.5rem;
}
html[data-coreui-theme=dark] .weavecolors-skeleton .skeleton-item {
  background: linear-gradient(90deg, #2c3034 25%, #404552 50%, #2c3034 75%);
  background-size: 200% 100%;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/WeaveTable/WeaveTable.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,sDAAA;EACA,kDAAA;EACA,0BAAA;EACA,8BAAA;EACA,iDAAA;AACF;AACE;EACE,oDAAA;EACA,yDAAA;EACA,+CAAA;EACA,0BAAA;EACA,8BAAA;EACA,iDAAA;AACJ;AAGE;EACE,kDAAA;EACA,gBAAA;AADJ;AAIE;;;;;;EAME,kDAAA;AAFJ;AAII;;;;;;EACE,kDAAA;AAGN;AACE;EACE,kDAAA;EACA,uCAAA;EACA,wCAAA;AACJ;AACI;EACE,kDAAA;AACN;AAEI;EACE,uCAAA;EACA,8BAAA;AAAN;AAIE;EACE,WAAA;EACA,8BAAA;AAFJ;AAII;EACE,kDAAA;EACA,gBAAA;EACA,wCAAA;AAFN;AAIM;EACE,eAAA;EACA,yBAAA;AAFR;AAIQ;EACE,2CAAA;EACA,YAAA;AAFV;AAMM;EACE,kDAAA;AAJR;AAQI;EACE,kDAAA;EACA,yBAAA;AANN;AAQM;EACE,kDAAA;EACA,mDAAA;AANR;AASM;EACE,kDAAA;AAPR;AASQ;EACE,kDAAA;AAPV;AAeI;EACE,kBAAA;EACA,yBAAA;AAbN;AAeM;EACE,2BAAA;EACA,yCAAA;AAbR;AAgBM;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;AAdR;AAkBI;EACE,yBAAA;AAhBN;AAkBM;EACE,cAAA;EACA,qBAAA;AAhBR;AAqBM;EACE,2BAAA;EACA,kBAAA;AAnBR;AAyBE;EACE,wCAAA;EACA,4CAAA;EACA,kBAAA;EACA,eAAA;EACA,+CAAA;AAvBJ;AA0BM;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;AAxBR;AA2BM;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;AAzBR;AA4BM;EACE,uCAAA;EACA,wCAAA;EACA,8BAAA;AA1BR;AA4BQ;EACE,uCAAA;EACA,iDAAA;AA1BV;AA8BM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA5BR;AA8BQ;EACE,SAAA;EACA,YAAA;AA5BV;AA+BQ;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AA7BV;AAgCQ;EACE,WAAA;EACA,cAAA;EACA,kBAAA;AA9BV;AAkCM;EACE,kBAAA;AAhCR;AAkCQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,2BAAA;EACA,UAAA;EACA,oBAAA;AAhCV;AAmCQ;EACE,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,uCAAA;EACA,8BAAA;EACA,yBAAA;AAjCV;AAmCU;EACE,uCAAA;EACA,iDAAA;EACA,uCAAA;EACA,8BAAA;AAjCZ;AAoCU;EACE,2BAAA;EACA,YAAA;AAlCZ;AAsCQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,UAAA;AApCV;AAsCU;EACE,cAAA;EACA,gBAAA;AApCZ;AAyCU;EACE,gCAAA;EACA,mCAAA;EACA,iCAAA;EACA,oCAAA;EACA,kCAAA;EACA,2BAAA;EACA,0BAAA;AAvCZ;AAyCY;EACE,wDAAA;EACA,yDAAA;AAvCd;AA0CY;EACE,gCAAA;AAxCd;AA2CY;EAEE,gCAAA;EACA,6DAAA;EACA,0BAAA;AA1Cd;AA6CY;EACE,mBAAA;EACA,cAAA;AA3Cd;AA6Cc;EACE,kCAAA;AA3ChB;AA8Cc;EACE,yBAAA;EACA,6BAAA;AA5ChB;AAgDY;EACE,uBAAA;EACA,+BAAA;AA9Cd;AAgDc;EACE,sBAAA;EACA,uBAAA;AA9ChB;AAiDc;EACE,cAAA;AA/ChB;AAoDU;EACE,oCAAA;EACA,2BAAA;EACA,+CAAA;EACA,mDAAA;EACA,2BAAA;AAlDZ;AAoDY;EACE,kDAAA;EACA,yDAAA;AAlDd;AAqDY;EACE,0BAAA;EACA,8BAAA;EACA,2CAAA;AAnDd;AAqDc;EACE,sDAAA;EACA,gEAAA;AAnDhB;AAsDc;EACE,kDAAA;EACA,oCAAA;EACA,kCAAA;EACA,8BAAA;AApDhB;AAsDgB;EACE,gCAAA;EACA,6DAAA;AApDlB;AA0Dc;EACE,oCAAA;EACA,8BAAA;EACA,cAAA;AAxDhB;AA0DgB;EACE,kCAAA;AAxDlB;AA2DgB;EAEE,oCAAA;AA1DlB;AA4DkB;EACE,4DAAA;AA1DpB;AA8DgB;EACE,oCAAA;EACA,sBAAA;AA5DlB;AAwEI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;AAtEN;AAyEI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AAvEN;AAyEM;EACE,gCAAA;EACA,qBAAA;AAvER;AAyEQ;EACE,0BAAA;AAvEV;AA8EE;EACE,gBAAA;AA5EJ;AA+EM;EACE,8BAAA;EACA,uCAAA;EACA,wCAAA;AA7ER;AA+EQ;EACE,gCAAA;EACA,wCAAA;EACA,uCAAA;AA7EV;AAiFM;EACE,2CAAA;EACA,uCAAA;EACA,YAAA;AA/ER;AAkFM;EACE,2BAAA;EACA,uCAAA;EACA,wCAAA;AAhFR;AAsFE;EACE,uCAAA;EACA,8BAAA;EACA,wCAAA;AApFJ;AAsFI;EACE,uCAAA;EACA,8BAAA;EACA,uCAAA;EACA,iDAAA;AApFN;AAuFI;EACE,uCAAA;EACA,8BAAA;AArFN;AA0FE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AAxFJ;AA0FI;EACE,YAAA;EACA,qBAAA;EACA,yCAAA;AAxFN;AA6FE;EACE;IACE,0CAAA;EA3FJ;EA6FE;IACE,2CAAA;EA3FJ;EA6FE;IACE,wCAAA;EA3FJ;AACF;AA+FE;EACE;IACE,aAAA;EA7FJ;EA+FI;IACE,qBAAA;EA7FN;EAgGI;IACE,mBAAA;EA9FN;EAmGI;IACE,sBAAA;IACA,WAAA;IACA,+BAAA;EAjGN;EAmGM;IACE,mBAAA;IACA,8BAAA;EAjGR;EAsGE;IACE,sBAAA;IACA,SAAA;IACA,+BAAA;EApGJ;EAsGI;IACE,uBAAA;EApGN;EAuGI;IACE,kBAAA;EArGN;AACF;AAyGE;EAEI;IACE,cAAA;IACA,eAAA;EAxGN;EA2GI;IACE,sBAAA;EAzGN;EA2GM;IACE,iBAAA;EAzGR;EA4GM;IACE,mBAAA;EA1GR;EAgHI;IACE,mBAAA;IACA,yBAAA;EA9GN;EAiHI;IACE,mBAAA;IACA,kBAAA;EA/GN;AACF;AAqHI;EACE,wCAAA;AAnHN;AAsHI;EACE,8CAAA;AApHN;AAwHM;EACE,gDAAA;AAtHR;AA0HI;EACE,wCAAA;AAxHN;AA4HM;EACE,wCAAA;AA1HR;AAgIE;EACE,+EAAA;AA9HJ;AAkIE;EACE,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,sBAAA;AAhIJ;AAmIE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAjIJ;AAmII;EACE,qBAAA;EACA,8CAAA;AAjIN;AAoII;EACE,+BAAA;AAlIN;AAsIE;EACE,gGAAA;AApIJ;AAsII;EACE,8FAAA;AApIN;AAwIE;EACE,6DAAA;EACA,2BAAA;AAtIJ;AAwII;EACE,4GAAA;AAtIN;AAyII;EACE,0BAAA;EACA,iDAAA;AAvIN;AA2IE;EACE,kCAAA;AAzIJ;AA4IE;EACE,aAAA;EACA,2DAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,kDAAA;AA1IJ;AA4II;EACE,uCAAA;EACA,iDAAA;EACA,yCAAA;AA1IN;AA8IE;EACE,gDAAA;AA5IJ;AA+IE;EACE,eAAA;AA7IJ;AA+II;EACE,mCAAA;EACA,qCAAA;EACA,cAAA;AA7IN;AAgJI;EACE,kCAAA;EACA,qCAAA;AA9IN;AAiJI;EACE,2CAAA;EACA,mBAAA;AA/IN;AAmJE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,6DAAA;EACA,kBAAA;EACA,kDAAA;EACA,yBAAA;AAjJJ;AAmJI;EACE,2BAAA;EACA,wCAAA;AAjJN;AAoJI;EACE,4GAAA;EACA,iDAAA;AAlJN;AAoJM;EACE,wCAAA;AAlJR;AAuJE;EACE,kBAAA;EACA,gBAAA;EACA,0CAAA;EACA,yBAAA;EACA,qBAAA;AArJJ;AAuJI;EACE,0CAAA;AArJN;AAyJE;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;AAvJJ;AAyJI;EACE,mCAAA;EACA,qCAAA;AAvJN;AA2JE;EACE;IACE,UAAA;IACA,4BAAA;EAzJJ;EA2JE;IACE,UAAA;IACA,wBAAA;EAzJJ;AACF;AA6JE;EACE;IACE,0BAAA;IACA,SAAA;IACA,gBAAA;EA3JJ;EA8JE;IACE,0BAAA;EA5JJ;EA+JE;IACE,gBAAA;EA7JJ;EAgKE;IACE,mBAAA;IACA,iBAAA;EA9JJ;AACF;AAiKE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AA/JJ;;AAmKA,oEAAA;AAEE;EACE,WAAA;EACA,uCAAA;EACA,oBAAA;AAjKJ;AAoKE;EACE,gBAAA;AAlKJ;;AAsKA;EACE,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,kDAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EAoZA,iCAAA;AAtjBF;AAoKE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yEAAA;AAlKJ;AAqKE;EACE,6DAAA;EACA,iDAAA;EACA,yCAAA;AAnKJ;AAsKE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,yDAAA;AApKJ;AAsKI;EACE,wDAAA;AApKN;AAuKI;EACE,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AArKN;AAuKM;EACE,cAAA;AArKR;AAyKI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AAvKN;AA0KI;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;AAxKN;AA0KM;EACE,2BAAA;EACA,0CAAA;AAxKR;AA2KM;EACE,qDAAA;EACA,YAAA;EACA,qBAAA;AAzKR;AA2KQ;EACE,qDAAA;AAzKV;AA6KM;EACE,qDAAA;EACA,YAAA;EACA,qBAAA;AA3KR;AA6KQ;EACE,qDAAA;AA3KV;AAiLE;EACE,aAAA;EACA,SAAA;EACA,0BAAA;AA/KJ;AAiLI;EALF;IAMI,8BAAA;EA9KJ;AACF;AAiLE;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kDAAA;EACA,0CAAA;EACA,yBAAA;AA/KJ;AAiLI;EACE,2BAAA;EACA,0CAAA;AA/KN;AAkLI;EACE,uCAAA;EACA,iDAAA;EACA,yCAAA;AAhLN;AAkLM;EACE,yCAAA;AAhLR;AAoLI;EACE,8BAAA;AAlLN;AAqLI;EACE,8BAAA;AAnLN;AAuLE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,oBAAA;EACA,yDAAA;AArLJ;AAuLI;EACE,wDAAA;AArLN;AAwLI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8CAAA;AAtLN;AAwLM;EACE,qDAAA;AAtLR;AAyLM;EACE,qDAAA;AAvLR;AA2LI;EACE,SAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,qCAAA;AAzLN;AA2LM;EACE,kCAAA;AAzLR;AA6LI;EACE,qDAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AA3LN;AA+LE;EACE,aAAA;EACA,SAAA;EACA,4DAAA;AA7LJ;AA+LI;EALF;IAMI,0BAAA;EA5LJ;AACF;AA+LE;EACE,6DAAA;EACA,mBAAA;EACA,gBAAA;EACA,kDAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AA7LJ;AA+LI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AA7LN;AAgMI;EACE,uCAAA;EACA,2CAAA;EACA,yCAAA;AA9LN;AAiMI;EACE,iFAAA;EACA,iDAAA;AA/LN;AAiMM;EACE,0CAAA;AA/LR;AAmMI;EACE,oDAAA;AAjMN;AAoMI;EACE,oDAAA;AAlMN;AAsME;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDAAA;AApMJ;AAsMI;EACE,wDAAA;AApMN;AAuMI;EACE,qDAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AArMN;AAwMI;EACE,oCAAA;EACA,kCAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;AAtMN;AAwMM;EACE,oCAAA;EACA,sCAAA;AAtMR;AA4MI;EACE,mBAAA;AA1MN;AA4MM;EACE,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,qBAAA;AA1MR;AA4MQ;EACE,cAAA;AA1MV;AA8MM;EACE,mBAAA;EACA,0CAAA;EACA,kBAAA;AA5MR;AA8MQ;EACE,cAAA;AA5MV;AAiNI;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AA/MN;AAkNI;EACE,qCAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAhNN;AAkNM;EACE,oCAAA;EACA,sCAAA;EACA,sBAAA;AAhNR;AAmNM;EACE,oCAAA;EACA,sCAAA;AAjNR;AAmNQ;EACE,qCAAA;EACA,sCAAA;AAjNV;AAqNM;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAnNR;AAqNQ;EACE,cAAA;AAnNV;AAuNM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;AArNR;AAuNQ;EACE,cAAA;AArNV;AA4NE;EA5WF;IA6WI,aAAA;EAzNF;EA2NE;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;EAzNJ;EA2NI;IACE,uBAAA;EAzNN;EA6NE;IACE,aAAA;EA3NJ;EA8NE;IACE,aAAA;EA5NJ;EA+NE;IACE,0BAAA;EA7NJ;AACF;AAgOE;EAtYF;IAuYI,iBAAA;IACA,mBAAA;EA7NF;EAgOI;IACE,iBAAA;EA9NN;EAiOI;IACE,kBAAA;IACA,yBAAA;EA/NN;EAmOE;IACE,0BAAA;EAjOJ;AACF;;AAwOA;EACE;IACE,UAAA;IACA,2BAAA;EArOF;EAuOA;IACE,UAAA;IACA,wBAAA;EArOF;AACF;AA0OE;EACE,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AAxOJ;AA0OI;EACE,yEAAA;EACA,0BAAA;AAxON;;AA6OA;EACE;IACE,2BAAA;EA1OF;EA4OA;IACE,4BAAA;EA1OF;AACF","sourcesContent":[".weave-table-container {\n  --table-bg-color: #fff;\n  --table-border-color: var(--cui-border-color, #d8dbe0);\n  --table-text-color: var(--cui-body-color, #4f5d73);\n  --filter-bg-color: #f8f9fa;\n  --filter-border-color: #dee2e6;\n  --filter-focus-color: var(--cui-primary, #0d6efd);\n  \n  html[data-coreui-theme=\"dark\"] & {\n    --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);\n    --table-border-color: var(--cui-dark-border-subtle, #333);\n    --table-text-color: var(--cui-body-color, #fff);\n    --filter-bg-color: #2a2d3a;\n    --filter-border-color: #404552;\n    --filter-focus-color: var(--cui-primary, #0d6efd);\n  }\n\n  // Tablo stilleri\n  .table {\n    border-color: var(--table-border-color) !important;\n    margin-bottom: 0;\n  }\n\n  .table,\n  .table thead,\n  .table tbody,\n  .table tr,\n  .table th,\n  .table td {\n    border-color: var(--table-border-color) !important;\n    \n    &:hover {\n      border-color: var(--table-border-color) !important;\n    }\n  }\n\n  .card {\n    border-color: var(--table-border-color) !important;\n    background-color: var(--table-bg-color);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    \n    &:hover {\n      border-color: var(--table-border-color) !important;\n    }\n    \n    .card-body {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n    }\n  }\n\n  .weave-table {\n    width: 100%;\n    color: var(--table-text-color);\n    \n    .table-header-cell {\n      border-color: var(--table-border-color) !important;\n      font-weight: 600;\n      background-color: var(--filter-bg-color);\n      \n      &.sortable-header {\n        cursor: pointer;\n        transition: all 0.2s ease;\n        \n        &:hover {\n          background-color: var(--filter-focus-color);\n          color: white;\n        }\n      }\n      \n      &:hover {\n        border-color: var(--table-border-color) !important;\n      }\n    }\n    \n    tbody tr {\n      border-color: var(--table-border-color) !important;\n      transition: all 0.2s ease;\n      \n      &:hover {\n        border-color: var(--table-border-color) !important;\n        background-color: var(--filter-bg-color) !important;\n      }\n      \n      td {\n        border-color: var(--table-border-color) !important;\n        \n        &:hover {\n          border-color: var(--table-border-color) !important;\n        }\n      }\n    }\n  }\n\n  // Filtre kontrol paneli\n  .filter-controls {\n    .filter-toggle-btn {\n      position: relative;\n      transition: all 0.3s ease;\n      \n      &:hover {\n        transform: translateY(-1px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n      }\n      \n      .filter-count-badge {\n        background-color: #dc3545;\n        color: white;\n        border-radius: 50%;\n        padding: 2px 6px;\n        font-size: 0.75rem;\n        font-weight: 600;\n        min-width: 18px;\n        text-align: center;\n        display: inline-block;\n        animation: pulse 2s infinite;\n      }\n    }\n    \n    .clear-filters-btn {\n      transition: all 0.2s ease;\n      \n      &:hover {\n        color: #dc3545;\n        border-color: #dc3545;\n      }\n    }\n    \n    .results-info {\n      .filtered-info {\n        color: var(--cui-secondary);\n        font-style: italic;\n      }\n    }\n  }\n\n  // Filtre paneli\n  .filter-panel {\n    background-color: var(--filter-bg-color);\n    border: 1px solid var(--filter-border-color);\n    border-radius: 8px;\n    padding: 1.5rem;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);\n    \n    .filter-field {\n      .filter-label {\n        display: block;\n        font-size: 0.875rem;\n        font-weight: 500;\n        color: var(--table-text-color);\n        margin-bottom: 0.5rem;\n      }\n\n      .filter-label--compact {\n        font-size: 0.75rem;\n        line-height: 1.2;\n        min-height: 1.3125rem;\n        display: flex;\n        align-items: flex-end;\n      }\n\n      .filter-select {\n        background-color: var(--table-bg-color);\n        border-color: var(--filter-border-color);\n        color: var(--table-text-color);\n\n        &:focus {\n          border-color: var(--filter-focus-color);\n          box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);\n        }\n      }\n\n      .decimal-input-group {\n        display: flex;\n        align-items: center;\n        gap: 0.35rem;\n\n        .whole-input {\n          flex: 1;\n          min-width: 0;\n        }\n\n        .decimal-separator {\n          color: #6c757d;\n          font-weight: 600;\n          line-height: 1;\n        }\n\n        .decimal-input {\n          width: 64px;\n          flex: 0 0 64px;\n          text-align: center;\n        }\n      }\n      \n      .filter-input-wrapper {\n        position: relative;\n        \n        .filter-input-icon {\n          position: absolute;\n          left: 10px;\n          top: 50%;\n          transform: translateY(-50%);\n          color: var(--cui-secondary);\n          z-index: 5;\n          pointer-events: none;\n        }\n        \n        .filter-input {\n          padding-left: 35px;\n          padding-right: 35px;\n          border: 1px solid var(--filter-border-color);\n          background-color: var(--table-bg-color);\n          color: var(--table-text-color);\n          transition: all 0.2s ease;\n          \n          &:focus {\n            border-color: var(--filter-focus-color);\n            box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n            background-color: var(--table-bg-color);\n            color: var(--table-text-color);\n          }\n          \n          &::placeholder {\n            color: var(--cui-secondary);\n            opacity: 0.7;\n          }\n        }\n        \n        .filter-clear-btn {\n          position: absolute;\n          right: 5px;\n          top: 50%;\n          transform: translateY(-50%);\n          padding: 0;\n          width: 20px;\n          height: 20px;\n          border: none;\n          background: none;\n          color: var(--cui-secondary);\n          z-index: 5;\n          \n          &:hover {\n            color: #dc3545;\n            background: none;\n          }\n        }\n\n        .filter-searchable-select {\n          .select-trigger {\n            min-height: 1.9375rem !important;\n            padding: 0.375rem 0.5rem !important;\n            background-color: #fff !important;\n            border: 1px solid #b1b7c1 !important;\n            border-radius: 0.375rem !important;\n            box-shadow: none !important;\n            transform: none !important;\n\n            html[data-coreui-theme=\"dark\"] & {\n              background-color: var(--cui-body-bg, #212631) !important;\n              border-color: var(--cui-border-color, #495057) !important;\n            }\n\n            &:hover:not(.disabled) {\n              border-color: #86b7fe !important;\n            }\n\n            &:focus,\n            &.open {\n              border-color: #86b7fe !important;\n              box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;\n              transform: none !important;\n            }\n\n            .select-value {\n              font-size: 0.875rem;\n              color: #212529;\n\n              html[data-coreui-theme=\"dark\"] & {\n                color: var(--cui-body-color, #fff);\n              }\n\n              .placeholder {\n                color: #6c757d !important;\n                font-style: normal !important;\n              }\n            }\n\n            .select-icons {\n              gap: 0.15rem !important;\n              margin-left: 0.25rem !important;\n\n              .clear-btn {\n                width: 1rem !important;\n                height: 1rem !important;\n              }\n\n              .chevron {\n                color: #6c757d;\n              }\n            }\n          }\n\n          .select-dropdown {\n            border: 1px solid #b1b7c1 !important;\n            border-top: none !important;\n            border-radius: 0 0 0.375rem 0.375rem !important;\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n            background: #fff !important;\n\n            html[data-coreui-theme=\"dark\"] & {\n              background: var(--cui-body-bg, #212631) !important;\n              border-color: var(--cui-border-color, #495057) !important;\n            }\n\n            .search-container {\n              padding: 0.5rem !important;\n              background: #f8f9fa !important;\n              border-bottom: 1px solid #dee2e6 !important;\n\n              html[data-coreui-theme=\"dark\"] & {\n                background: var(--cui-tertiary-bg, #2c3034) !important;\n                border-bottom-color: var(--cui-border-color, #495057) !important;\n              }\n\n              .search-input {\n                padding: 0.375rem 0.75rem 0.375rem 2rem !important;\n                border: 1px solid #ced4da !important;\n                border-radius: 0.375rem !important;\n                font-size: 0.875rem !important;\n\n                &:focus {\n                  border-color: #86b7fe !important;\n                  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;\n                }\n              }\n            }\n\n            .options-container {\n              .option-item {\n                padding: 0.375rem 0.75rem !important;\n                font-size: 0.875rem !important;\n                color: #212529;\n\n                html[data-coreui-theme=\"dark\"] & {\n                  color: var(--cui-body-color, #fff);\n                }\n\n                &:hover,\n                &.highlighted {\n                  background-color: #e9ecef !important;\n\n                  html[data-coreui-theme=\"dark\"] & {\n                    background-color: var(--cui-tertiary-bg, #2c3034) !important;\n                  }\n                }\n\n                &.selected {\n                  background-color: #0d6efd !important;\n                  color: #fff !important;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Veri bulunamadı mesajları\n  .no-data-message {\n    .loading-message {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--table-text-color);\n    }\n    \n    .no-results-message {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      color: var(--cui-secondary);\n      \n      .btn-link {\n        color: var(--filter-focus-color);\n        text-decoration: none;\n        \n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n\n  // Pagination stilleri\n  .pagination {\n    margin-bottom: 0;\n    \n    .page-item {\n      .page-link {\n        color: var(--table-text-color);\n        background-color: var(--table-bg-color);\n        border-color: var(--filter-border-color);\n        \n        &:hover {\n          color: var(--filter-focus-color);\n          background-color: var(--filter-bg-color);\n          border-color: var(--filter-focus-color);\n        }\n      }\n      \n      &.active .page-link {\n        background-color: var(--filter-focus-color);\n        border-color: var(--filter-focus-color);\n        color: white;\n      }\n      \n      &.disabled .page-link {\n        color: var(--cui-secondary);\n        background-color: var(--table-bg-color);\n        border-color: var(--filter-border-color);\n      }\n    }\n  }\n\n  // Form select stilleri\n  .form-select {\n    background-color: var(--table-bg-color);\n    color: var(--table-text-color);\n    border-color: var(--filter-border-color);\n    \n    &:focus {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n      border-color: var(--filter-focus-color);\n      box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n    }\n    \n    option {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n    }\n  }\n\n  // Action butonları\n  .cursor-pointer {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    transition: all 0.2s ease;\n    border-radius: 4px;\n    \n    &:hover {\n      opacity: 0.8;\n      transform: scale(1.1);\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    }\n  }\n\n  // Animasyonlar\n  @keyframes pulse {\n    0% {\n      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);\n    }\n    70% {\n      box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);\n    }\n    100% {\n      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);\n    }\n  }\n\n  // Responsive tasarım\n  @media (max-width: 768px) {\n    .filter-panel {\n      padding: 1rem;\n      \n      .row {\n        --bs-gutter-x: 0.5rem;\n      }\n      \n      .filter-field {\n        margin-bottom: 1rem;\n      }\n    }\n    \n    .filter-controls {\n      .d-flex {\n        flex-direction: column;\n        gap: 0.5rem;\n        align-items: stretch !important;\n        \n        .d-flex {\n          flex-direction: row;\n          align-items: center !important;\n        }\n      }\n    }\n    \n    .d-flex.justify-content-between.align-items-center.mt-3 {\n      flex-direction: column;\n      gap: 1rem;\n      align-items: stretch !important;\n      \n      .d-flex {\n        justify-content: center;\n      }\n      \n      .text-muted {\n        text-align: center;\n      }\n    }\n  }\n\n  @media (max-width: 576px) {\n    .filter-panel {\n      .col-lg-3, .col-md-4, .col-sm-6 {\n        flex: 0 0 100%;\n        max-width: 100%;\n      }\n      \n      .filter-field {\n        margin-bottom: 0.75rem;\n        \n        .filter-label {\n          font-size: 0.8rem;\n        }\n        \n        .filter-input {\n          font-size: 0.875rem;\n        }\n      }\n    }\n    \n    .filter-controls {\n      .filter-toggle-btn, .clear-filters-btn {\n        font-size: 0.875rem;\n        padding: 0.375rem 0.75rem;\n      }\n      \n      .results-info {\n        font-size: 0.875rem;\n        text-align: center;\n      }\n    }\n  }\n\n  // Dark mode özel düzenlemeler\n  html[data-coreui-theme=\"dark\"] & {\n    .card {\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    }\n    \n    .filter-panel {\n      box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);\n    }\n    \n    .filter-input {\n      &:focus {\n        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.4);\n      }\n    }\n    \n    .cursor-pointer:hover {\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    }\n    \n    .pagination .page-item {\n      .page-link:hover {\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n      }\n    }\n  }\n\n  // Smooth transitions\n  * {\n    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n  }\n\n  // Master-Detail Styles\n  .expand-cell {\n    width: 40px;\n    padding: 0.5rem 0.25rem !important;\n    text-align: center;\n    vertical-align: middle;\n  }\n\n  .expand-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border: none;\n    \n    &:hover {\n      transform: scale(1.1);\n      box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);\n    }\n    \n    .expand-icon {\n      transition: transform 0.3s ease;\n    }\n  }\n\n  .expanded-row {\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n    }\n  }\n\n  .detail-row {\n    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n    border-top: none !important;\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);\n    }\n    \n    .detail-cell {\n      padding: 1.5rem !important;\n      border-top: 2px solid var(--cui-primary, #0d6efd);\n    }\n  }\n\n  .detail-content {\n    animation: slideDown 0.3s ease-out;\n  }\n\n  .detail-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 1.5rem;\n    padding: 1rem;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    border: 1px solid var(--cui-border-color, #d8dbe0);\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-dark-border-subtle, #333);\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n    }\n  }\n\n  .detail-grid.detail-grid--preview {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .detail-item--action {\n    cursor: pointer;\n\n    .detail-value--action {\n      background: rgba(25, 135, 84, 0.12);\n      border-color: rgba(25, 135, 84, 0.25);\n      color: #157347;\n    }\n\n    &:hover .detail-value--action {\n      background: rgba(25, 135, 84, 0.2);\n      border-color: rgba(25, 135, 84, 0.35);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba(13, 110, 253, 0.45);\n      outline-offset: 2px;\n    }\n  }\n\n  .detail-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 1rem;\n    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n    border-radius: 8px;\n    border: 1px solid var(--cui-border-color, #d8dbe0);\n    transition: all 0.3s ease;\n    \n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    }\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);\n      border-color: var(--cui-dark-border-subtle, #333);\n      \n      &:hover {\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n      }\n    }\n  }\n\n  .detail-label {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: var(--cui-secondary-color, #6c757d);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    \n    html[data-coreui-theme=\"dark\"] & {\n      color: var(--cui-secondary-color, #8a93a2);\n    }\n  }\n\n  .detail-value {\n    font-size: 1rem;\n    font-weight: 700;\n    color: var(--cui-primary, #0d6efd);\n    padding: 0.5rem;\n    background: rgba(13, 110, 253, 0.1);\n    border-radius: 6px;\n    text-align: center;\n    border: 1px solid rgba(13, 110, 253, 0.2);\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: rgba(13, 110, 253, 0.2);\n      border-color: rgba(13, 110, 253, 0.3);\n    }\n  }\n\n  @keyframes slideDown {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  // Responsive adjustments for master-detail\n  @media (max-width: 768px) {\n    .detail-grid {\n      grid-template-columns: 1fr;\n      gap: 1rem;\n      padding: 0.75rem;\n    }\n\n    .detail-grid.detail-grid--preview {\n      grid-template-columns: 1fr;\n    }\n    \n    .detail-item {\n      padding: 0.75rem;\n    }\n    \n    .detail-value {\n      font-size: 0.875rem;\n      padding: 0.375rem;\n    }\n  }\n\n  .caglik-preview-modal-body {\n    max-height: 84vh;\n    overflow: auto;\n    padding: 0.5rem;\n  }\n}\n\n/* Keep Caglik preview modal wider than CoreUI's default xl width. */\n.caglik-preview-modal {\n  .modal-dialog {\n    width: 98vw;\n    max-width: min(2000px, 98vw) !important;\n    margin: 0.75rem auto;\n  }\n\n  .modal-content {\n    min-height: 86vh;\n  }\n}\n// Enhanced WeaveColors Section Styles\n.weavecolors-section {\n  background: linear-gradient(135deg, #f8f9ff 0%, #fff0f6 100%);\n  border-radius: 16px;\n  padding: 1.5rem;\n  border: 1px solid var(--cui-border-color, #e0e6ff);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  position: relative;\n  overflow: hidden;\n  \n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%);\n  }\n  \n  html[data-coreui-theme=\"dark\"] & {\n    background: linear-gradient(135deg, #1a1d29 0%, #252841 100%);\n    border-color: var(--cui-dark-border-subtle, #333);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n  }\n\n  .weavecolors-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n    padding-bottom: 1rem;\n    border-bottom: 2px solid var(--cui-border-color, #e0e6ff);\n    \n    html[data-coreui-theme=\"dark\"] & {\n      border-bottom-color: var(--cui-dark-border-subtle, #333);\n    }\n\n    .section-title {\n      color: var(--cui-primary, #667eea);\n      font-weight: 700;\n      font-size: 1.25rem;\n      margin: 0;\n      display: flex;\n      align-items: center;\n      \n      html[data-coreui-theme=\"dark\"] & {\n        color: #8b9dc3;\n      }\n    }\n\n    .color-summary {\n      display: flex;\n      gap: 0.75rem;\n      align-items: center;\n    }\n\n    .summary-badge {\n      display: inline-flex;\n      align-items: center;\n      padding: 0.5rem 1rem;\n      border-radius: 20px;\n      font-size: 0.875rem;\n      font-weight: 600;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      border: 2px solid;\n      transition: all 0.3s ease;\n      \n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n      }\n\n      &.weft-badge {\n        background: linear-gradient(135deg, #ff6b6b, #ff8e8e);\n        color: white;\n        border-color: #ff6b6b;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          background: linear-gradient(135deg, #e74c3c, #c0392b);\n        }\n      }\n\n      &.warp-badge {\n        background: linear-gradient(135deg, #4ecdc4, #44a08d);\n        color: white;\n        border-color: #4ecdc4;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          background: linear-gradient(135deg, #16a085, #138d75);\n        }\n      }\n    }\n  }\n\n  .weavecolors-grid {\n    display: grid;\n    gap: 2rem;\n    grid-template-columns: 1fr;\n    \n    @media (min-width: 992px) {\n      grid-template-columns: 1fr 1fr;\n    }\n  }\n\n  .thread-type-section {\n    background: white;\n    border-radius: 12px;\n    padding: 1.5rem;\n    border: 1px solid var(--cui-border-color, #e0e6ff);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n    transition: all 0.3s ease;\n    \n    &:hover {\n      transform: translateY(-4px);\n      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    }\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-dark-border-subtle, #333);\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n      \n      &:hover {\n        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n      }\n    }\n\n    &.weft-section {\n      border-left: 4px solid #ff6b6b;\n    }\n\n    &.warp-section {\n      border-left: 4px solid #4ecdc4;\n    }\n  }\n\n  .thread-type-header {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid var(--cui-border-color, #e0e6ff);\n    \n    html[data-coreui-theme=\"dark\"] & {\n      border-bottom-color: var(--cui-dark-border-subtle, #333);\n    }\n\n    .thread-type-indicator {\n      width: 12px;\n      height: 12px;\n      border-radius: 50%;\n      box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);\n      \n      &.weft-indicator {\n        background: linear-gradient(135deg, #ff6b6b, #ff8e8e);\n      }\n\n      &.warp-indicator {\n        background: linear-gradient(135deg, #4ecdc4, #44a08d);\n      }\n    }\n\n    .thread-type-title {\n      flex: 1;\n      margin: 0;\n      font-size: 1.1rem;\n      font-weight: 600;\n      color: var(--cui-body-color, #4f5d73);\n      \n      html[data-coreui-theme=\"dark\"] & {\n        color: var(--cui-body-color, #fff);\n      }\n    }\n\n    .thread-count-badge {\n      background: linear-gradient(135deg, #667eea, #764ba2);\n      color: white;\n      padding: 0.25rem 0.75rem;\n      border-radius: 12px;\n      font-size: 0.75rem;\n      font-weight: 700;\n      min-width: 24px;\n      text-align: center;\n    }\n  }\n\n  .colors-container {\n    display: grid;\n    gap: 1rem;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    \n    @media (max-width: 768px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .color-card {\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    border-radius: 12px;\n    padding: 1.25rem;\n    border: 1px solid var(--cui-border-color, #e0e6ff);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    overflow: hidden;\n    \n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 3px;\n      transition: all 0.3s ease;\n    }\n    \n    &:hover {\n      transform: translateY(-4px) scale(1.02);\n      box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);\n      border-color: var(--cui-primary, #667eea);\n    }\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: linear-gradient(135deg, var(--cui-dark-bg, #212631) 0%, #1a1d29 100%);\n      border-color: var(--cui-dark-border-subtle, #333);\n      \n      &:hover {\n        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.4);\n      }\n    }\n\n    &.weft-card::before {\n      background: linear-gradient(90deg, #ff6b6b, #ff8e8e);\n    }\n\n    &.warp-card::before {\n      background: linear-gradient(90deg, #4ecdc4, #44a08d);\n    }\n  }\n\n  .color-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n    padding-bottom: 0.75rem;\n    border-bottom: 1px solid var(--cui-border-color, #e0e6ff);\n    \n    html[data-coreui-theme=\"dark\"] & {\n      border-bottom-color: var(--cui-dark-border-subtle, #333);\n    }\n\n    .color-id-badge {\n      background: linear-gradient(135deg, #667eea, #764ba2);\n      color: white;\n      padding: 0.375rem 0.75rem;\n      border-radius: 8px;\n      font-size: 0.875rem;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n\n    .position-indicator {\n      background: rgba(102, 126, 234, 0.1);\n      color: var(--cui-primary, #667eea);\n      padding: 0.25rem 0.5rem;\n      border-radius: 6px;\n      font-size: 0.75rem;\n      font-weight: 600;\n      border: 1px solid rgba(102, 126, 234, 0.2);\n      \n      html[data-coreui-theme=\"dark\"] & {\n        background: rgba(102, 126, 234, 0.2);\n        border-color: rgba(102, 126, 234, 0.3);\n      }\n    }\n  }\n\n  .color-card-body {\n    .yarn-info {\n      margin-bottom: 1rem;\n      \n      .yarn-code {\n        font-size: 1.1rem;\n        font-weight: 700;\n        color: var(--cui-primary, #667eea);\n        margin-bottom: 0.5rem;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: #8b9dc3;\n        }\n      }\n\n      .yarn-name {\n        font-size: 0.875rem;\n        color: var(--cui-secondary-color, #6c757d);\n        font-style: italic;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: #8a93a2;\n        }\n      }\n    }\n\n    .thread-specs {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 0.75rem;\n    }\n\n    .spec-item {\n      background: rgba(102, 126, 234, 0.05);\n      border: 1px solid rgba(102, 126, 234, 0.1);\n      border-radius: 8px;\n      padding: 0.75rem;\n      text-align: center;\n      transition: all 0.3s ease;\n      \n      &:hover {\n        background: rgba(102, 126, 234, 0.1);\n        border-color: rgba(102, 126, 234, 0.2);\n        transform: scale(1.05);\n      }\n      \n      html[data-coreui-theme=\"dark\"] & {\n        background: rgba(102, 126, 234, 0.1);\n        border-color: rgba(102, 126, 234, 0.2);\n        \n        &:hover {\n          background: rgba(102, 126, 234, 0.15);\n          border-color: rgba(102, 126, 234, 0.3);\n        }\n      }\n\n      .spec-label {\n        display: block;\n        font-size: 0.7rem;\n        font-weight: 600;\n        color: var(--cui-secondary-color, #6c757d);\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        margin-bottom: 0.25rem;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: #8a93a2;\n        }\n      }\n\n      .spec-value {\n        display: block;\n        font-size: 1rem;\n        font-weight: 700;\n        color: var(--cui-primary, #667eea);\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: #8b9dc3;\n        }\n      }\n    }\n  }\n\n  // Responsive adjustments\n  @media (max-width: 768px) {\n    padding: 1rem;\n    \n    .weavecolors-header {\n      flex-direction: column;\n      gap: 1rem;\n      align-items: stretch;\n      \n      .color-summary {\n        justify-content: center;\n      }\n    }\n    \n    .thread-type-section {\n      padding: 1rem;\n    }\n    \n    .color-card {\n      padding: 1rem;\n    }\n    \n    .thread-specs {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  @media (max-width: 576px) {\n    margin: 0 -0.5rem;\n    border-radius: 12px;\n    \n    .weavecolors-header {\n      .section-title {\n        font-size: 1.1rem;\n      }\n      \n      .summary-badge {\n        font-size: 0.75rem;\n        padding: 0.375rem 0.75rem;\n      }\n    }\n    \n    .colors-container {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  // Animation for section reveal\n  animation: fadeInUp 0.6s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Loading skeleton for async content\n.weavecolors-skeleton {\n  .skeleton-item {\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: skeleton-loading 1.5s infinite;\n    border-radius: 8px;\n    height: 20px;\n    margin-bottom: 0.5rem;\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: linear-gradient(90deg, #2c3034 25%, #404552 50%, #2c3034 75%);\n      background-size: 200% 100%;\n    }\n  }\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
